(function () {
  var orbit = document.querySelector('[data-ing-orbit]');
  if (!orbit) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  var nodes = orbit.querySelectorAll('.nd-ing-hero__node');
  if (!nodes.length) return;

  orbit.classList.add('is-animated');

  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY * 0.04;
        orbit.style.setProperty('--orbit-tilt', y + 'deg');
        ticking = false;
      });
    },
    { passive: true }
  );
})();
